/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { connect } from 'react-redux';
import { isRecaptchaChallengeMessage } from 'shared-ui/recaptcha';
import { getErrors, passTypesSelectors, validationSelectors } from '../reducers';
import PassSelectionError from '../components/PassSelectionError';

function mapStateToProps(state) {
    const errors = getErrors(state, 'reservations', 'facilities', 'passTypes');

    Object.keys(errors).forEach((key) => {
        if (isRecaptchaChallengeMessage(errors[key])) {
            delete errors[key];
        }
    });

    const validationErrors = validationSelectors.getValidationErrors(state);
    if (validationErrors.length) {
        errors.validation = validationErrors;
    }
    return {
        validationErrors: validationSelectors.getValidationProblems(state),
        passTypes: passTypesSelectors.getPassTypes(state),
        errors,
    };
}

export default connect(mapStateToProps)(PassSelectionError);
